import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function Tracker() {
    const location = useLocation();
    useEffect(() => {
        api.post("/track", { path: location.pathname, referrer: document.referrer || null }).catch(() => {});
    }, [location.pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <Tracker />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
            <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
    );
}

export default App;
